import * as Yup from 'yup';

export default (t: any) => Yup.object().shape({
  name: Yup.string()
    .required(t('common:validation.name.required')),
  surname: Yup.string()
    .required(t('common:validation.surname.required')),
  email: Yup.string()
    .email(t('common:validation.email.invalid'))
    .required(t('common:validation.email.required')),
  // Próg jak w backendzie — krótsze hasło odrzuciłby dopiero serwer
  password: Yup.string()
    .min(10, t('common:validation.password.minLength'))
    .max(100, t('common:validation.password.tooLong'))
    .required(t('common:validation.password.required')),
});

export type Values = {
  name: string;
  surname: string;
  email: string;
  password: string;
};

export const INITIAL_VALUES: Values = {
  name: '',
  surname: '',
  email: '',
  password: '',
};
